import { userProjectInteractionTypes } from '@/Models';
import Resources from '@/Resources.js';
import { buildScreenBalloonAction } from '@/Utils/Admin/ScreenActionsUtility.js';

export const tabKeys = {
    all: 'all',
    backed: 'backed',
    followed: 'followed',
};

export const keyToFilterMap = {
    [tabKeys.followed]: [
        userProjectInteractionTypes[userProjectInteractionTypes.followed].value,
    ],
    [tabKeys.backed]: [
        userProjectInteractionTypes[userProjectInteractionTypes.backed].value,
    ],
    [tabKeys.all]: [
        userProjectInteractionTypes[userProjectInteractionTypes.backed].value,
        userProjectInteractionTypes[userProjectInteractionTypes.followed].value,
    ],
};

export const buildCardActions = (projectId, isArchived, archiveActionPromise, restoreActionPromise) => {
    const archiveAction = async () => {
        await archiveActionPromise(projectId);
    };
    const restoreAction = async () => {
        await restoreActionPromise(projectId);
    };

    return [
        buildScreenBalloonAction({
            text: Resources.BackerCenter.ArchiveProjectArchiveStatusLabel,
            icon: 'box-archive',
            qa: 'MoveToArchive',
            onClick: archiveAction,
            isVisible: !isArchived,
        }),
        buildScreenBalloonAction({
            text: Resources.BackerCenter.RestoreProjectArchiveStatusLabel,
            icon: 'box-archive',
            qa: 'RestoreFromArchive',
            onClick: restoreAction,
            isVisible: isArchived,
        }),
    ]
        .filter(action => action.buttonVisibility)
        .map(action => ({ ...action, title: action.text }));
};
